import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import {
    Accordion,
    AccordionItem,
    AccordionItemPanel,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemState,
} from "react-accessible-accordion";
const produccion = require("assets/img/icons/produccion.png");
const produccion_activo = require("assets/img/icons/produccion_activo.png");

export const ProduccionBodegaItem = ({
    permisos,
    proveedor,
    proveedor_admin,
    location,
    moduloId,
    isItemSelected,
}) => {
    if (!permisos) return null;
    if (
        !permisos.prod_bodega_ingresos &&
        !permisos.prod_bodega_salidas &&
        !permisos.prod_bodega_control_calidad &&
        !permisos.prod_bodega_cierres_inventario
    )
        return null;
    if (proveedor === true || proveedor_admin === true) return null;

    return (
        <div className="nav-item">
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <AccordionItemState>
                            {({ expanded }) => {
                                const isSelected = isItemSelected(
                                    moduloId,
                                    location.hash,
                                    expanded,
                                );

                                return (
                                    <div
                                        className={`nav-link ${isSelected ? "active" : ""}`}
                                    >
                                        <img
                                            src={
                                                isSelected
                                                    ? produccion_activo
                                                    : produccion
                                            }
                                            className="icon-menu"
                                            alt=""
                                        />
                                        BODEGA PRODUCCIÓN
                                    </div>
                                );
                            }}
                        </AccordionItemState>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemState>
                    {({ expanded }) => {
                        const isSelected = isItemSelected(
                            moduloId,
                            location.hash,
                            expanded,
                        );

                        return (
                            isSelected && (
                                <AccordionItemPanel
                                    className={
                                        isSelected ? "acordion-expanded" : ""
                                    }
                                >
                                    <div className="pb-2">
                                        {permisos.prod_bodega_ingresos &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/produccion-bodega/ingresos"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/produccion-bodega/ingresos",
                                                            )
                                                        }
                                                    >
                                                        INGRESOS
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.prod_bodega_salidas &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/produccion-bodega/salidas"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/produccion-bodega/salidas",
                                                            )
                                                        }
                                                    >
                                                        SALIDAS
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.prod_bodega_control_calidad &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/produccion-bodega/control-calidad"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/produccion-bodega/control-calidad",
                                                            )
                                                        }
                                                    >
                                                        CONTROL DE CALIDAD
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.prod_bodega_cierres_inventario &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/produccion-bodega/inventario"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/produccion-bodega/inventario",
                                                            )
                                                        }
                                                    >
                                                        INVENTARIO
                                                    </NavLink>
                                                </div>
                                            )}
                                    </div>
                                </AccordionItemPanel>
                            )
                        );
                    }}
                </AccordionItemState>
            </AccordionItem>
        </div>
    );
};
